var _defs, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_63",
    "data-name": "Group 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.55,
    height: 47.55,
    viewBox: "0 0 47.55 47.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 48.406,
    y1: -11.079,
    x2: 48.406,
    y2: -10.185,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb92e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#dda228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#aa7c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#7c5b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#563f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#36280a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1e1605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#0d0902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#030200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 1.02,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#442914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#3d230f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#2a1301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    xlinkHref: "#radial-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M-1582.439,350.081a23.774,23.774,0,0,1-23.774,23.775,23.775,23.775,0,0,1-23.776-23.775,23.774,23.774,0,0,1,23.776-23.775A23.773,23.773,0,0,1-1582.439,350.081Z",
    transform: "translate(1629.989 -326.306)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M-1574.4,340.121c0,5.96-7.1,10.792-15.863,10.792s-15.864-4.832-15.864-10.792,7.1-10.791,15.864-10.791S-1574.4,334.161-1574.4,340.121Z",
    transform: "translate(1614.037 -328.328)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M-1610.273,404.523c0-6.935,7.717-12.557,17.239-12.557s17.238,5.622,17.238,12.557-7.719,12.556-17.238,12.556S-1610.273,411.457-1610.273,404.523Z",
    transform: "translate(1616.81 -370.198)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(10.53 26.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M-1584.983,416.124a14.5,14.5,0,0,1-13.163-8.489.921.921,0,0,1,.457-1.22.921.921,0,0,1,1.219.457,12.653,12.653,0,0,0,11.487,7.41,12.655,12.655,0,0,0,11.486-7.41.923.923,0,0,1,1.219-.457.921.921,0,0,1,.457,1.22A14.5,14.5,0,0,1-1584.983,416.124Z",
    transform: "translate(1598.229 -406.333)",
    fill: "url(#radial-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(13.967 16.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M-1583.105,377.536a2.378,2.378,0,0,1-2.378,2.378,2.379,2.379,0,0,1-2.379-2.378,2.379,2.379,0,0,1,2.379-2.378A2.378,2.378,0,0,1-1583.105,377.536Z",
    transform: "translate(1587.862 -375.158)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.378,
    cy: 2.378,
    rx: 2.378,
    ry: 2.378,
    transform: "translate(14.861)",
    fill: "url(#radial-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.e4ac30dc16378661fd63da336f6b6642.svg";
export { ForwardRef as ReactComponent };